import axios from 'axios'
import library from '../../../utils/Library'

export const getAllLockedEntityLegDecl = async (subId) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('declarations') + '/getAllLockedEntityLegalDecl'

  return await axios({
    url: URL,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: { suborganizationId: subId }
  })
}
